<template>
  <div class="header-wrapper">
    <div class="logo" :class="{zoom:isZoom}">
      <router-link :to="{name:'home'}">
        <img :src="logo" alt="">
      </router-link>
    </div>
    <div class="nav" :class="{home:isHome}">
      <ul class="clearfix">
        <li class="item"
            v-for="(item,index) in navName"
            :key="index"
            :data-index="index"
            @mouseenter.stop="showSecondNav"
            @mouseleave.stop="hideSecondNav"
        >
          <router-link :to="item.firstName.link ? item.firstName.link : `#${index}?id=`">
            <span class="en">{{item.firstName.en}}</span>
            <span class="cn">{{item.firstName.cn}}</span>
          </router-link>
          <div v-show=" n == index">
            <div class="hide-nav" v-if="item.children">
              <div class="wrapper">
                <div class="main">
                  <ul class="second-nav">
                    <li class="s-item"
                        v-for="(items,index) in item.children"
                        :key="index"
                        :data-index="index"
                        @mouseenter.stop="navHover"
                        @click = "hideNav"
                    >
                      <router-link :to="items.secondName.link">
                        <span class="s-en">{{items.secondName.en}}</span>
                        <span class="s-cn">{{items.secondName.cn}}</span>
                      </router-link>
                      <ul class="three-nav" v-if="items.children">
                        <li class="t-item" v-for="(itemt,index) in items.children" :key="index">
                          <router-link :to="itemt.threeName.link">
                            <span class="t-en">{{itemt.threeName.en}}</span>
                          </router-link>
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <div class="icon">
                    <a href="#">
                      <i class="icon-font icon-wechat"></i>
                      <span class="txt">WeChat</span>
                    </a>
                    <a href="https://weibo.com/u/6456964273" target="_blank">
                      <i class="icon-font icon-weibo"></i>
                      <span class="txt">MICRO-BLOG</span>
                    </a>
                  </div>
                </div>
                <div class="img-wrap">
                  <a href="#" v-show="i == 0">
                    <img src="/static/img/nav1.jpg" alt="">
                  </a>
                  <a href="#" v-show="i == 1">
                    <img src="/static/img/nav2.jpg" alt="">
                  </a>
                  <a href="#" v-show="i == 2">
                    <img src="/static/img/nav3.jpg" alt="">
                  </a>
                  <a href="#" v-show="i == 3">
                    <img src="/static/img/nav2.jpg" alt="">
                  </a>
                </div>
              </div>
              <div class="bg" v-if="item.children"></div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'v-header',
    data() {
      return {
        logo: '/static/img/logo-black.png',
        i: 0,
        n: null,
        isHome: false,
        isZoom: false
      }
    },
    created() {
      this.navName = [
        {
          firstName: {
            en: 'Home',
            cn: '首页',
            link: '/home'
          }
        },
        {
          firstName: {
            en: 'Campaign',
            cn: '形象视觉',
            link: ''
          },
          children: [
            {
              secondName: {
                en: 'Campaign',
                cn: '形象大片',
                link: ''
              },
              children: []
            },
            {
              secondName: {
                en: 'lookBook',
                cn: '经典搭配',
                link: '/image/lookBook?id=82'
              },
              children: []
            },
            {
              secondName: {
                en: 'Shooting Tidbits',
                cn: '拍摄花絮',
                link: '/image/shootingTidbits'
              },
            },
          ]
        },
        {
          firstName: {
            en: 'News',
            cn: '新闻资讯',
            link: '/news'
          },
          children: [
            {
              secondName: {
                en: 'Brand news',
                cn: '品牌新闻',
                link: '/news/brandNews'
              }
            },
            {
              secondName: {
                en: 'Fashion show',
                cn: '秀场直击',
                link: '/news/fashionShow'
              }
            },
            /*   {
                 secondName: {
                   en: 'Star',
                   cn: '明星演绎',
                   link: '/news/star'
                 },
               },
               {
                 secondName: {
                   en: 'Stores open',
                   cn: '新店开业',
                   link: '/news/storesOpen'
                 },
               }*/
          ]
        },
        {
          firstName: {
            en: 'About',
            cn: '关于品牌',
            link: '/about'
          }
        },
        {
          firstName: {
            en: 'Stores',
            cn: '门店形象',
            link: '/stores',
          }
        },
        {
          firstName: {
            en: 'Vip',
            cn: '会员尊享',
            link: '/vip',
          }
        },
        {
          firstName: {
            en: 'Contact',
            cn: '联系我们',
            link: '/contact'
          }
        }
      ];
      const that = this;
      if (this.$route.name === 'home') {
        this._changeHeadState(true, '/static/img/logo-white.png');
      }

      // 获取子菜单
      [84, 81].forEach(writeSubmenu);

      function writeSubmenu(id, index) {
        that.api.getSubmenu(id).then(function (response) {
          response.data.forEach(function (item) {
            that.navName[1].children[index].children.push({
              threeName: {
                en: item.title_en,
                link: '/image/' + (index === 0 ? 'campaign' : 'lookBook') + '?id=' + item.id
              }
            });
          });
          if(index == 0){
            that.navName[1].firstName.link = '/image/campaign?id='+response.data[0].id;
            that.navName[1].children[0].secondName.link = '/image/campaign?id='+response.data[0].id;
          }
        });
      }
    },
    mounted() {
      window.addEventListener('scroll', this._ScrollTop);
    },
    watch: {
      $route() {
        if (this.$route.name === 'home') {
          this._changeHeadState(true, '/static/img/logo-white.png');
        } else {
          this._changeHeadState(false, '/static/img/logo-black.png');
        }
      }
    },
    methods: {
      navHover(e) {
        this.i = e.target.getAttribute('data-index');
      },
      showSecondNav(e) {
        this.n = e.target.getAttribute('data-index');
      },
      hideSecondNav() {
        this.n = null;
      },
      hideNav() {
        this.hideSecondNav();
      },
      _changeHeadState(boolean, src) {
        this.isHome = boolean;
        this.logo = src
      },
      _ScrollTop() {
        let scrollTop = this.scrollTop();
        this.isZoom = scrollTop > 78;
      }
    }
  }

</script>

<style lang="scss" scoped>
  @import "~common/scss/mixin";

  .header-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    width: 100%;
    padding: 0 60px;
    transition: all 0.3s;
    @include maxScreenWidth(768) {
      display: none;
    }
    &.Bg {
      transform: translateY(-100%);
      background: url("../assets/bj.jpg") repeat;
      background-size: contain;
    }
    .logo {
      float: left;
      margin-top: 28px;
      width: 197px;
      height: 42px;
      transition: all 0.3s;
      &.zoom {
        transform: scale(0.6);
      }
      a {
        display: block;
      }
    }
    .nav {
      float: right;
      &.home {
        .item {
          > a {
            color: #fff;
          }
          .hide-nav {
            a {
              color: #fff;
            }
            .three-nav {
              .t-item {
                a {
                  &:after {
                    border-color: #fff;
                  }
                }
              }
            }
            .icon {
              a {
                &:hover {
                  .icon-font, .txt {
                    opacity: 1;
                  }
                }
              }
              .icon-font, .txt {
                opacity: 0.7;
                color: #fff;
              }
            }
          }
        }
      }
      .item {
        float: left;
        margin-right: 50px;
        padding: 40px 12px;
        font-size: 14px;
        line-height: 28px;
        @include maxScreenWidth(1280) {
          margin-right: 40px;
        }
        @include maxScreenWidth(980) {
          margin-right: 20px;
        }
        @include maxScreenWidth(850) {
          margin-right: 7px;
        }
        > a {
          width: 56px;
          position: relative;
          display: block;
          color: #000;
          text-align: center;
          &:hover {
            .cn {
              opacity: 1;
            }
            .en {
              opacity: 0;
            }
          }
        }
        span {
          transition: opacity 0.3s;
        }
        .cn {
          position: absolute;
          top: 0;
          left: 0;
          opacity: 0;
        }
        .active {
          .cn {
            opacity: 1;
          }
          .en {
            opacity: 0;
          }
        }
        &:first-child {
          .cn {
            left: 15px;
          }
        }
        &:last-child {
          margin-right: 0;
        }
      }
      .hide-nav {
        position: absolute;
        top: 106px;
        left: 0;
        width: 100%;
        height: 560px;
        /*background: url(../assets/navbj.jpg) repeat;*/
        background-color: #a39c80;
        @include border-top-1px(#c3bb9e);
        font-family: 'Times New Roman';
        a {
          color: #000;
          display: block;
        }
        .wrapper {
          text-align: center;
        }
        .main {
          display: inline-block;
          @include maxScreenWidth(1024) {
            margin-left: -28%;
          }
          @include maxScreenWidth(850) {

          }
        }
        .second-nav {
          width: 552px;
          text-align: left;
          margin-top: 77px;
        }
        .s-item {
          position: relative;
          margin-bottom: 51px;
          .active.cur-active {
            .s-cn, .s-en {
              opacity: 1;
            }
          }
          &:hover {
            .s-cn, .s-en {
              opacity: 1;
            }
            .three-nav {
              opacity: 1;
            }
          }
        }
        .bg {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 108px;
          /*background: url(../assets/bj.jpg) repeat;*/
          background-color: #BBB090;
          z-index: -1;
        }
        .s-en {
          opacity: 0.5;
          font-size: 50px;
        }
        .s-cn {
          opacity: 0.5;
          display: inline-block;
          padding-left: 13px;
        }
        .three-nav {
          position: absolute;
          top: 0;
          right: 0;
          opacity: 0;
          transition: all 0.3s;
          @include maxScreenWidth(1280) {
            right: 10%;
          }
          .t-item {
            a {
              position: relative;
              @include border-bottom-1px(#000);
              &:after {
                width: 0;
                transition: all 0.3s;
              }
              &:hover {
                &:after {
                  width: 100%;
                }
              }
              &.cur-active.active {
                &:after {
                  width: 100%;
                }
              }
            }
          }
        }
        .img-wrap {
          display: inline-block;
          margin: 77px 0 0 120px;
          vertical-align: top;
          @include maxScreenWidth(1280) {
            margin: 77px 0 0 0;
          }
          @include maxScreenWidth(1280) {
            position: relative;
            right: 50px;
          }
          a {
            position: absolute;
            width: 250px;
            &:nth-child(1) {
              z-index: 3;
            }
            &:nth-child(2) {
              z-index: 2;
            }
            &:nth-child(3) {
              z-index: 1;
            }
          }
        }
        .icon {
          text-align: left;
          a {
            &:hover {
              .icon-font, .txt {
                opacity: 1;
              }
              &:nth-child(1) {
                &:after {
                  transform: scale(1);
                }
              }
            }
            &:nth-child(1) {
              position: relative;
              &:after {
                content: "";
                position: absolute;
                top: 0;
                left: 125px;
                width: 84px;
                height: 84px;
                background: #fff url(../assets/wx.jpg) no-repeat;
                background-size: cover;
                transform: scale(0);
                transition: all 0.3s;
              }
            }
          }
          .icon-font, .txt {
            color: #000;
            opacity: 0.5;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/VHeader.vue